import React from 'react';
import connectFinalFormField from '../../libs/final-form/connectFinalFormField';
import Popover from '../basic/Popover';
import Responsive from '../basic/Responsive';
import { css } from 'styled-components';
import TouchableItem from '../basic/TouchableItem';
import { useTranslation } from 'react-i18next';

const languageByCode = {
  id: {
    code: 'id',
    name: 'Bahasa',
    flag:
      'https://s3-ap-southeast-1.amazonaws.com/static.rupiahtoken.com/images/flag/indonesia-flag.png'
  },
  en: {
    code: 'en',
    name: 'English',
    flag:
      'https://s3-ap-southeast-1.amazonaws.com/static.rupiahtoken.com/images/flag/america-flag.png'
  }
};

const LanguagePopoverSelector = ({ value: _value, onChange = undefined }) => {
  const { i18n } = useTranslation();
  const value = _value || i18n.language;
  const handleOnChange = onChange
    ? onChange
    : code => {
        i18n.changeLanguage(code);
      };
  const selectedLanguage = languageByCode[value] || languageByCode['id'];
  return (
    <Popover
      popoverContent={
        <div>
          {Object.entries(languageByCode).map(([languageCode, language]) => (
            <TouchableItem
              key={languageCode}
              onClick={() => handleOnChange(languageCode)}
              css={'display: block'}
            >
              <div
                css={css`
                  display: flex;
                  align-items: center;
                  padding: 12px 6px;
                `}
              >
                <div style={{ width: 35, paddingRight: 10 }}>
                  <Responsive ratio={1}>
                    <img src={language.flag} alt={`language - ${language.name}`} />
                  </Responsive>
                </div>
                <div css={'flex: 1'}>{language.name}</div>
              </div>
            </TouchableItem>
          ))}
        </div>
      }
    >
      <div>
        <div
          css={css`
            display: flex;
            align-items: center;
          `}
        >
          <div style={{ width: 35, paddingRight: 4 }}>
            <Responsive ratio={1}>
              <img src={selectedLanguage.flag} alt={`language - ${selectedLanguage.name}`} />
            </Responsive>
          </div>
          {selectedLanguage.code.toUpperCase()}
        </div>
      </div>
    </Popover>
  );
};

export default connectFinalFormField(LanguagePopoverSelector);
